import { Icon, Message } from '@docs/kd-d2c-components';
import intl from '@/internationalzation/intl';
import { Button } from 'antd';
import './index.less';
import { eed_mario_icon_mouse_line } from '@src/assets/icons';
import { useEffect, useState } from 'react';
import { useComputerData } from '@src/stores/useComputerData';
import { postConversationUserOperatedApi } from '@src/services/walle';
import { isMobile } from '@/utils/user-agent';
import { EventBus } from '@/utils/event-bus';
import { GlobalEventType } from '@/types';
interface Props {
  id: string;
}
export const TakeOver = ({ id }: Props) => {
  const [visible, setVisible] = useState(true);
  const { activeVNC } = useComputerData();
  useEffect(() => {
    activeVNC();
  }, []);
  const notifyServer = (operateType: string) => {
    postConversationUserOperatedApi({
      operateType,
      helpId: id,
    });
  };
  const onSkip = () => {
    setVisible(false);
    notifyServer('skip');
    EventBus.emit(GlobalEventType.USER_REJECT);
  };
  const onTakeOver = () => {
    if (isMobile) {
      Message.info({
        message: intl.t('请在PC端进行接管操作'),
      });
      return;
    }
    const button = document.getElementById('vnc-take-over-button');
    if (button) {
      button.click();
    }
    setVisible(false);
    notifyServer('done');
  };
  if (!visible) {
    return null;
  }
  return (
    <div className="take-over-item">
      <span className="take-over-item-text">
        {intl.t('通过选择接管浏览器完成操作。')}
      </span>
      <div className="take-over-item-actions">
        <Button
          type="text"
          onClick={onSkip}
          style={{ color: 'var(--color-text-secondary)' }}
        >
          {intl.t('拒绝并跳过')}
        </Button>
        <Button
          type="text"
          onClick={onTakeOver}
          icon={
            <Icon
              icon={eed_mario_icon_mouse_line}
              size={16}
              color={'var(--color-text-primary)'}
              style={{ marginRight: -4 }}
            />
          }
          style={{ fontWeight: 500 }}
        >
          {intl.t('接管')}
        </Button>
      </div>
    </div>
  );
};
